// F6_1 Tab切换1
import { ITopTabSwitch, paddingTopClassMap, paddingBottomClassMap } from '@/common/pd-meta-components-types'
import PdMedia from '@/components/pd-media/pd-media'
import clsx from 'clsx'
import { FC, useEffect, useState } from 'react'
import SlidingTabs from '../../pd-sliding-tabs'
import Link from 'next/link'
import AngleRight from '@/components/pd-angle-right/pd-angle-right'
import TitleAndDesc from '../../title-and-desc'

const TopTabSwitch: FC<ITopTabSwitch> = ({ theme, title, desc, mediaGroup, mediaBorderRadius, paddingTop = 'px120', paddingBottom = 'px120' }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [isMobileDevice, setMobileDevice] = useState<boolean>(false)

  useEffect(() => {
    setMobileDevice(window?.innerWidth < 1024)
  }, [])

  return (
    <div className={clsx('w-full h-fit', paddingTopClassMap[paddingTop], paddingBottomClassMap[paddingBottom], `pd-theme-${theme}`, 'bg-container-primary')}>
      <div className={clsx('w-full max-w-300 mx-auto')}>
        <TitleAndDesc title={title} desc={desc} />
        <SlidingTabs
          contentBoxClassName={clsx('w-full h-553px laptop:[aspect-ratio:2/1]')}
          tabsBoxClassName={clsx('pb-3 laptop:pb-6 flex justify-center')}
          tabsContainerClassName="laptop:rounded-full"
          containerClassName={clsx('w-full px-6 laptop:px-0')}
          tabLabels={mediaGroup.map((item) => item.tabTitle || '')}
          bgColor="bg-container-third"
          tabEleClassName="rounded-full hover:bg-white/20 active:bg-black/20"
          activeTabChange={(index) => {
            setActiveIndex(index)
          }}
        ></SlidingTabs>
        <div
          className={clsx(
            'w-full flex flex-col justify-between',
            'laptop:flex-row laptop:[aspect-ratio:2/1]',
            'bg-container-secondary',
            'overflow-hidden'
          )}
          style={{ borderRadius: !isMobileDevice && mediaBorderRadius ? `${mediaBorderRadius}px` : '0' }}
        >
          <div className={clsx('h-fit laptop:w-1/2 laptop:h-full', 'p-6 laptop:p-12 overflow-y-scroll scroll-hidden')}>
            <div className={clsx('flex flex-col justify-center')}>
              {mediaGroup[activeIndex].title && (
                <h2 className={clsx('text-24 laptop:text-36 font-semibold', 'mb-2 laptop:mb-4', 'text-fc-primary')}>
                  {mediaGroup[activeIndex].title}
                </h2>
              )}
              {mediaGroup[activeIndex].subTitle && (
                <h3 className={clsx('text-16 laptop:text-20', 'mb-3 laptop:mb-6', 'text-fc-primary')}>
                  {mediaGroup[activeIndex].subTitle}
                </h3>
              )}
              {mediaGroup[activeIndex].desc && (
                <p className={clsx('text-16 laptop:text-14', 'mb-3 laptop:mb-6', 'text-fc-secondary')}>
                  {mediaGroup[activeIndex].desc}
                </p>
              )}
              {mediaGroup[activeIndex].downloadTitle && (
                <Link href={mediaGroup[activeIndex].jumpUrl || mediaGroup[activeIndex].downloadUrl || ''} passHref>
                  <a className="text-14 flex items-center mr-auto group">
                    <span className="text-brand-primary group-hover:text-brand-hover group-active:text-brand-active">
                      {mediaGroup[activeIndex].downloadTitle}
                    </span>
                    <AngleRight
                      size="4x8"
                      pathClassName="stroke-brand-primary group-hover:stroke-brand-hover group-active:stroke-brand-active"
                    />
                  </a>
                </Link>
              )}
            </div>
          </div>
          <div className={clsx('w-full [aspect-ratio:1/1] laptop:w-1/2 h-full')}>
            <PdMedia src={mediaGroup[activeIndex].mediaUrl || ''} mask={false} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopTabSwitch
